import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { INREVIEWSTATUS,READYTOPUBLISHSTATUS, EXPIRED, EXPIRINGSOON, ACTIVE} from '../../../constant';

import {
  registeredStatusIcon,
  publishedStatusIcon,
  deactivatedStatusIcon,
  arrowRight,
  Tooltip,
  Icon,
} from '@marketplace/ui-elements';
import { IApplicationFormatted } from '../../../types';

import classes from './app-list.module.scss';
import { IdCell } from './components';
import { Paginator } from "primereact/paginator";
import { useState } from 'react';
import { FetchDeveloperApplicationsParams } from '@marketplace/api';
import { ProgressSpinner } from 'primereact/progressspinner';

type TAppListProps = {
  appList: IApplicationFormatted[] | [];
  fetchDevelopersApplications: (params?: FetchDeveloperApplicationsParams) => Promise<void>;
  totalRecords?: number;
  loading?: boolean;
  loaded?: boolean;
};

const iconsStatuses = {
  REGISTERED: (
    <Icon
      iconClassName={classes.status_icon}
      glyph={Icon.glyphs.svg['registered-status-icon']}
    />
  ),
  PUBLISHED: (
    <Icon
      iconClassName={classes.status_icon}
      glyph={Icon.glyphs.svg['published-status-icon']}
    />
  ),
  DEACTIVATED: (
    <Icon
      iconClassName={classes.status_icon}
      glyph={Icon.glyphs.svg['deactivated-status-icon']}
    />
  ),
  CREATED: (
    <Icon
      iconClassName={classes.status_icon}
      glyph={Icon.glyphs.svg['created-status-icon']}
    />
  ),
  READYTOPUBLISH: (
    <Icon
      iconClassName={classes.status_icon}
      glyph={Icon.glyphs.svg['registered-status-icon']}
    />
  ),
  ERROR: (id: string) => (
    <Icon
      iconClassName={`${classes.secret_icon} errorHint-${id}`}
      glyph={Icon.glyphs.svg['error-red-icon']}
    />
  ),
  WARNING: (id: string) => (
    <Icon
      iconClassName={`${classes.secret_icon} warningHint-${id}`}
      glyph={Icon.glyphs.svg['warning-icon']}
    />
  )
};

export const AppList = ({ appList , fetchDevelopersApplications, totalRecords , loading, loaded }: TAppListProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString('en', {
      hour: '2-digit',
      minute: '2-digit',
    });
  const formatApplicationStatusColumn = (status:any) => {
    return status===READYTOPUBLISHSTATUS?INREVIEWSTATUS:status;
  };

  const handleSecretExpiryIcon = (secret_expiry_date_status: string, id: string) => {
    if (secret_expiry_date_status === ACTIVE) return null;
    
    // If already expired
    if (secret_expiry_date_status === EXPIRED) {  
      return (
        <span>
        {iconsStatuses.ERROR(id)}
        <Tooltip target={`.errorHint-${id}`}>
          {formatMessage({
            id: 'secret_expired_hint',
          })}
        </Tooltip>
      </span>
      )
    }

    // If expiring in 15 days or less
    else if (secret_expiry_date_status === EXPIRINGSOON) {
      return (
        <span>
          {iconsStatuses.WARNING(id)}
          <Tooltip target={`.warningHint-${id}`}>
            {formatMessage({
              id: 'secret_expires_soon_hint',
            })}
          </Tooltip>
        </span>
      )
    } 

    return null;
  }

  const handlePageChange = (e: { first: number; rows: number }) => {
    setFirst(e.first);
    setRows(e.rows);
    const page = Math.floor(e.first / e.rows) + 1;

    fetchDevelopersApplications({
      per_page: String(e.rows),
      page: String(page),
    });
  };
  return (
    <><div className={classes.table_container}>
      <div className={`${classes.table_row} ${classes.header}`}>
        <div className={`${classes.table_cell} ${classes.name_cell}`}>
          {formatMessage({ id: 'table_header_name' })}
        </div>
        <div className={classes.table_cell}>
          {formatMessage({ id: 'table_header_last_update' })}
        </div>
        <div className={classes.table_cell}>
          {formatMessage({ id: 'table_header_status' })}
        </div>
        {/* <div className={`${classes.table_cell} ${classes.id_cell}`}>
          {formatMessage({ id: 'table_header_ID_sandbox' })}
        </div> */}
        <div className={`${classes.table_cell} ${classes.id_cell}`}>
          {formatMessage({ id: 'table_header_ID_prodaction' })}
        </div>
        <div className={classes.table_cell}>
          {formatMessage({ id: 'table_header_Secret_Expiry_Date' })}
        </div>
        <div className={`${classes.table_cell} ${classes.link_cell}`}></div>
      </div>
      {loaded && (
      appList?.map(({ id, name, updated_at, status, client_id, secret_expiry_date, secret_expiry_date_status }) => (
        <Link to={`dashboard/application/${id}`} key={id}>
          <div className={classes.table_row}>
            <div className={`${classes.table_cell} ${classes.name_cell}`}>
              {name}
            </div>
            <div className={classes.table_cell}>{formatDate(updated_at)}</div>
            <div className={`${classes.table_cell} ${classes.status_cell}`}>
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
              {/* @ts-ignore */}
              {iconsStatuses[status]}
              {formatApplicationStatusColumn(status)}
            </div>
            {/* <div className={`${classes.table_cell} ${classes.id_cell}`}>
              <IdCell id={client_id} />
            </div> */}
            <div className={`${classes.table_cell} ${classes.id_cell}`}>
              <IdCell id={client_id} />
            </div>
            <div className={classes.table_cell}>
              <div className={classes.secret_cell}>
                <span>{secret_expiry_date ? formatDate(secret_expiry_date) : ''}</span>
                {handleSecretExpiryIcon(secret_expiry_date_status, id)}
              </div>
            </div>
            <div className={`${classes.table_cell} ${classes.link_cell}`}>
              <img src={arrowRight} alt="" />
            </div>
          </div>
        </Link>
      ))
    )}
      <Tooltip
        target={`.${classes.icon}`}
        content="Copied!"
        position="left"
        showEvent="click"
        hideDelay={2000}
      />
    </div>
    <div className={`${classes.pagination_container}`}>
    <Paginator
  first={first}
  rows={rows}
  totalRecords={totalRecords}
  rowsPerPageOptions={[10, 20, 50, 100]}
  onPageChange={handlePageChange}
/>
    </div>
    {loading && <div className={classes.spinner_container}><ProgressSpinner /></div>}
    </>
      );
};
